import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import {connect, setStore} from "trim-redux";
import {Translate} from "../../../../../config/Translate";
import {Link} from 'react-router-dom';
import {defaultVariabls} from "../../../../../config";
import Grid from "@material-ui/core/Grid/Grid";
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Menu from "@material-ui/core/Menu/Menu";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {withSnackbar} from "notistack";
import PowerSettingsNewRoundedIcon from '@material-ui/icons/PowerSettingsNewRounded';
import MoreVertRoundedIcon from '@material-ui/icons/MoreVertRounded';
import OpportunityCounter from "./OpportunityCounter";
import LaunchRoundedIcon from '@material-ui/icons/LaunchRounded';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import Button from "@material-ui/core/Button/Button";
import Typography from "@material-ui/core/Typography/Typography";
const useStyles = makeStyles((theme) => {
    return {
        profilePic: {
            fontSize: 24,
        },
        notiBtn: {
            justifyContent: 'flex-start',
            width: '100%',
            backgroundColor:"rgba(0, 0, 0, 0.04)",
            height: 56,
            borderRadius: 0,
            paddingLeft: '1rem',
            paddingRight: '1rem',
            [theme.breakpoints.up('sm')]: {
                height: 64,
            },
            [theme.breakpoints.up('md')]: {
                justifyContent: 'center',
                width: 'auto',
            },
            [theme.breakpoints.up('lg')]: {
                paddingLeft: '1.5rem',
                paddingRight: '1.5rem',
            },
            [theme.breakpoints.up('xl')]: {
                paddingLeft: '2.5rem',
                paddingRight: '2.5rem',
            },
        },
        userName: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: 16,
            color: '#313541',
        },
        designation: {
            marginTop: -2,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: theme.palette.text.secondary,
        },
        pointer: {
            cursor: 'pointer',
        },
        link:{
            cursor:"pointer"
        }
    };
});

const UserInfo = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLogout = () => {
        localStorage.removeItem('ACT');
        localStorage.removeItem('RET');
        setStore({
            isAuth : false,
            user : null,
        });
        window.location.replace(`${defaultVariabls.website}/auth/logout`);

        props.enqueueSnackbar(Translate.youLoggedOff, {
            variant: 'info',
        });
    };
    const classes = useStyles();
    const user = props.user;
    return (
        <>
            {
                !!user ?
                    <>
                    <Button
                        onClick={handleClick}
                        className={clsx(classes.notiBtn, 'notiBtn')}
                        startIcon={
                            !!user ?
                                <Avatar className={classes.profilePic} src={`${defaultVariabls.uploads}/FileManager/${user.avatar.name}_small.${user.avatar.extension}`}  alt={user.name} />
                                : null
                        }
                    >
                        {user.first_name} {user.last_name}
                    </Button>
                        <Menu
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            style={{top:49}}
                        >
                            <MenuItem onClick={handleClose}><Link to="/account/details"><IconButton size="small"><AccountCircleRoundedIcon fontSize="small"/></IconButton> {Translate.myAccount}</Link></MenuItem>
                            <MenuItem onClick={handleClose} ><Link to="/logout"><IconButton size="small"><PowerSettingsNewRoundedIcon fontSize="small"/></IconButton> {Translate.logOut}</Link></MenuItem>
                        </Menu>
                        </>
                    : null
            }
        </>
    );
};
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    cart: state.cart
});
export default withSnackbar(connect(mstp)(UserInfo));
